import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { IMAGES } from "../../constant/theme";
import Logoutbtn from "./Logoutbtn";
import ChangePasswordModal from "../../pages/ChangePasswordModal";
import FloatingSupport from "../../components/FloatingSupport/FloatingSupport";
import { isImpersonating, restoreAdminSession } from "../../../utils/impersonationSession";



const Header = ({ onNote }) => {
	const [headerFix, setheaderFix] = useState(false);
	const navigate = useNavigate();
	const [userData, setUserData] = useState(null);
	const [showModal, setShowModal] = useState(false);

	const handleShowModal = () => setShowModal(true);
	const handleCloseModal = () => setShowModal(false);
	const handleBackToAdmin = () => {
		if (restoreAdminSession()) {
			navigate("/dashboard");
			window.location.reload();
		}
	};

	useEffect(() => {
		if (localStorage.getItem('usertoken')) {
			setUserData(JSON.parse(localStorage.getItem('user')))
		}
		else {
			localStorage.removeItem('user')
			localStorage.removeItem("usertoken");
			localStorage.removeItem("is_subscribed");
			localStorage.removeItem("new_user");
			localStorage.removeItem("subscription_end_at");
			localStorage.removeItem("subscriptionActivePlan");
			localStorage.removeItem("subscription_data_types");
			navigate('/');
		}
		window.addEventListener("scroll", () => {
			setheaderFix(window.scrollY > 50);
		});
	}, []);


	return (
		<div className={`header ${headerFix ? "is-fixed" : ""}`}>
			<div className="header-content">
				<nav className="navbar navbar-expand">
					<div className="collapse navbar-collapse justify-content-between header-toolbar">
						<div className="header-left header-support-slot">
							<FloatingSupport inline={true} />
							<div className="input-group search-area">

							</div>
						</div>
						<ul className="navbar-nav header-right">

							{isImpersonating() && (
								<li className="nav-item align-items-center header-border me-2">
									<button className="btn btn-warning btn-sm back-to-admin-btn" onClick={handleBackToAdmin}>
										Back to Admin
									</button>
								</li>
							)}

							<li className="nav-item align-items-center header-border">
								<Logoutbtn />
							</li>
							<li className="nav-item ps-3">
								<Dropdown className="header-profile2">
									<Dropdown.Toggle className="nav-link i-false" as="div">
										<div className="header-info2 d-flex align-items-center">
											<div className="header-media">
												<img src={IMAGES.Tab1} alt="" />
											</div>
											<div className="header-info">
												<h6>{userData?.displayName}</h6>
												<p>{userData?.email}</p>
											</div>

										</div>
									</Dropdown.Toggle>

									{(userData?.role == "Admin" || userData?.role == "Staff") ?
										<Dropdown.Menu style={{ width: '200px', height: '90px', overflowY: "hidden" }}>
											<Dropdown.Item onClick={handleShowModal} style={{ textAlign: "center", marginTop: "-12px", fontSize: "13px" }}>Change Password</Dropdown.Item>
											<Dropdown.Item onClick={() => navigate("/notifyuserlist")} style={{ textAlign: "center", fontSize: "13px" }}>Notify Admin List</Dropdown.Item>
										</Dropdown.Menu>
										:
										<Dropdown.Menu style={{ width: '200px', height: '50px', overflowY: "hidden" }}>
											<Dropdown.Item onClick={handleShowModal} style={{ textAlign: "center", marginTop: "-12px", fontSize: "13px" }}>Change Password</Dropdown.Item>
										</Dropdown.Menu>
									}
									{/* <Dropdown.Menu align="end">
										<div className="card border-0 mb-0">
											<div className="card-header py-2">
												<div className="products">
													<img src={IMAGES.Tab1} className="avatar avatar-md" alt="" />
													<div>
														<h6>Thomas Fleming</h6>

													</div>
												</div>
											</div>
											<div className="card-body px-0 py-2">
												<Link to={"#"} className="dropdown-item ai-icon ">
													{SVGICON.User}{" "}
													<span className="ms-2">Profile </span>
												</Link>
												<Link to={"#"} className="dropdown-item ai-icon ">
													{SVGICON.Project}{" "}
													<span className="ms-2">My Project</span><span className="badge badge-sm badge-secondary light rounded-circle text-white ms-2">4</span>
												</Link>
												<Link to={"#"} className="dropdown-item ai-icon ">
													{SVGICON.Message}{" "}
													<span className="ms-2">Message </span>
												</Link>
												<Link to={"/#"} className="dropdown-item ai-icon ">
													{SVGICON.Notification} {" "}
													<span className="ms-2">Notification </span>
												</Link>
											</div>
											<div className="card-footer px-0 py-2">
												<Link to={"#"} className="dropdown-item ai-icon ">
													{SVGICON.Headersetting} {" "}
													<span className="ms-2">Settings </span>
												</Link>
												<LogoutPage />
											</div>
										</div>

									</Dropdown.Menu> */}
								</Dropdown>
								<ChangePasswordModal show={showModal} handleClose={handleCloseModal} />
							</li>
						</ul>


					</div>
				</nav>
			</div>
		</div>
	);
};

export default Header;

